import React, { useCallback, memo, useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { ArrowLeftCircleIcon, ArrowRightCircleIcon } from "@heroicons/react/24/outline";
import { Tabs, Tab } from "react-tabs-scrollable";

import { selectUserInfo } from '../features/users/userInfoSlice';
import { selectAll, selectedWebsite } from '../features/websites/websitesSlice'

function WebsiteTab() {
  const dispatch = useDispatch();
  const websites = useSelector(selectAll)
  const loadingWebsite = useSelector(state => state.websites.loading)
  const activeWebsite = useSelector(state => state.websites.activeWebsite)
  const userContext = useSelector(selectUserInfo);
  const [activeTab, setActiveTab] = useState(websites.findIndex(website => website?.id === activeWebsite?.id));

  useEffect(() => {
    if (!activeTab)
      setActiveTab(websites.findIndex(website => website?.id === activeWebsite?.id))
  }, [activeTab, websites, activeWebsite])

  const tabSelected = useCallback(website => {
    dispatch(selectedWebsite(website))
  }, [dispatch, selectedWebsite])

  const onTabClick = (_e, index) => {
    setActiveTab(index);
  };

  const loadWebsite = loadingWebsite && websites.length <= 0
  const emptyWebsite = websites?.length <= 0 && !loadingWebsite
  const unauthorized = websites.length > 0 && userContext?.user?.websites?.length === websites.length

  return (
    <nav title='Mes sites internet' className={`-mb-px px-5 border border-gray-200 bg-gray-200 rounded-full gap-2 p-1 ${loadWebsite || emptyWebsite || unauthorized ? 'flex justify-center' : ''}`}>

      {loadWebsite && <div className="animate-pulse text-sm text-gray-400">Chargement de vos sites...</div>}
      {emptyWebsite && <div className="text-sm text-gray-500">Aucun site enregistré.</div>}
      {unauthorized && <div className="text-sm text-gray-500">Vous n'avez accès à aucun site.</div>}

      {websites?.length > 0 && (<Tabs
        activeTab={activeTab}
        onTabClick={onTabClick}
        hideNavBtnsOnMobile={false}
        leftBtnIcon={<ArrowLeftCircleIcon className="h-5" />}
        rightBtnIcon={<ArrowRightCircleIcon className="h-5" />}
      >
        {websites.map((item, index) => {
          if ('websites' in userContext?.user && !userContext?.user?.websites?.includes(item.id)) return
          return <Tab key={index} title={item.title} onClick={() => tabSelected(item)}>
            {item.title}
          </Tab>
        })}
      </Tabs>)}
    </nav>
  )
}

export default memo(WebsiteTab)